export const AICategorisedBySystem = ({ size = "24" }: { size?: string }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12.0001" cy="12" r="10" fill="#9254E5" fill-opacity="0.5" />
      <circle
        cx="12.0001"
        cy="12"
        r="10"
        fill="url(#paint0_linear_6844_3736)"
      />
      <g clip-path="url(#clip0_6844_3736)">
        <path
          d="M12.2333 16.9372H10.6505L11.4734 13.6457H9.77296C9.60862 13.6457 9.44658 13.6072 9.29979 13.5333C9.15299 13.4594 9.0255 13.3522 8.92752 13.2203C8.82953 13.0884 8.76376 12.9354 8.73546 12.7735C8.70717 12.6116 8.71713 12.4454 8.76455 12.288L10.3448 7.06287H14.2398L13.0056 10.3543H14.6607C14.849 10.3544 15.0338 10.4056 15.1954 10.5023C15.357 10.599 15.4893 10.7377 15.5784 10.9037C15.6674 11.0696 15.7098 11.2566 15.7011 11.4447C15.6924 11.6328 15.6329 11.815 15.5288 11.972L12.2333 16.9372ZM11.7046 16.1143H11.7918L14.843 11.517C14.8649 11.484 14.8774 11.4457 14.8792 11.4062C14.8811 11.3667 14.8722 11.3274 14.8535 11.2926C14.8348 11.2577 14.807 11.2286 14.773 11.2083C14.7391 11.1879 14.7003 11.1772 14.6607 11.1772H11.8182L13.0525 7.88572H10.9554L9.55202 12.525C9.54155 12.5595 9.5393 12.596 9.54546 12.6315C9.55162 12.667 9.56601 12.7006 9.58749 12.7296C9.60897 12.7585 9.63693 12.782 9.66914 12.7982C9.70135 12.8144 9.7369 12.8229 9.77296 12.8229H12.5295L11.7046 16.1143Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_6844_3736"
          x1="12.0518"
          y1="2"
          x2="22.8269"
          y2="8.62105"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B29BFF" />
          <stop offset="1" stop-color="#8064DE" />
        </linearGradient>
        <clipPath id="clip0_6844_3736">
          <rect
            width="9.87429"
            height="9.87429"
            fill="white"
            transform="translate(7.06287 7.06287)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
